import { NgModule } from '@angular/core';

// import ngx-translate and the http loader
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
 import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { HttpClient } from '@angular/common/http';

@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [],
  exports: [
    TranslateModule,
  ],
})
export class  SharedTranslateModule {
  constructor() { }
}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  // const moduleName = route.data['moduleName'] as string;

  //  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
  return new MultiTranslateHttpLoader(http, [
    { prefix: './assets/translate/shared/', suffix: '.json' },
    // { prefix: './assets/translate/user-management/', suffix: '.json' },
    // { prefix: './assets/translate/criteria-forms/', suffix: '.json' },
  ]);
}
